'use client';

import { useEffect } from 'react';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import useGetVideos from '@/app/videos/utils/use-get-videos';
import { cn } from '@/utils/cn';
import { useLazyImport } from '@/utils/use-lazy-import';
import CarouselContent from './content';
import CarouselSkeleton from './skeleton';
import { useInteractifyParams } from '../utils/use-vid-params';
interface Props {
  title?: string;
  slug?: string;
  className?: string;
  productSlug?: string;
  withInfiniteLoading?: boolean;
  componentMeta?: {
    componentId: string;
    sortKey: string;
  };
}
const InteractifyCarousel = ({
  title,
  slug,
  className,
  productSlug,
  withInfiniteLoading = false,
  componentMeta
}: Props) => {
  const {
    removeInteractifyParam,
    activeInteractifyParam
  } = useInteractifyParams();
  const {
    ref,
    component: InteractifyVideoModal,
    forceLoad
  } = useLazyImport(() => import('@/features/interactify/video-modal'), {
    threshold: 0.1,
    rootMargin: '100px',
    triggerOnce: true
  });
  const {
    videos,
    isLoading
  } = useGetVideos({
    slug,
    productSlug
  });
  const closeHandler = () => {
    removeInteractifyParam();
  };
  useEffect(() => {
    if (!activeInteractifyParam) return;
    forceLoad();
  }, [forceLoad, activeInteractifyParam]);
  if (!isLoading && !videos.length) return null;
  const isInHomeOrLanidng = !!slug;
  const withShowMore = isInHomeOrLanidng && videos.length > 1;
  return <>
            {InteractifyVideoModal && <InteractifyVideoModal closeHandler={closeHandler} slug={slug} productSlug={productSlug} />}

            <div ref={ref} className={cn('flex flex-col gap-2 lg:gap-3', className)}>
                <div className={cn('flex items-center justify-between', {
        hidden: !title && !withShowMore,
        'justify-end': !title
      })}>
                    {title && <span className='py-1.5 text-body-14 font-bold text-text-black lg:py-0 lg:text-body-16'>
                            {title}
                        </span>}

                    {withShowMore && <AppNextLink href='/videos'>
                            <Button graphicStyle='text' size='medium'>
                                مشاهده همه
                            </Button>
                        </AppNextLink>}
                </div>

                {isLoading ? <CarouselSkeleton /> : <CarouselContent slug={slug} productSlug={productSlug} componentMeta={componentMeta} withInfiniteLoading={withInfiniteLoading} />}
            </div>
        </>;
};
export default InteractifyCarousel;